import { OnInit, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, merge, combineLatest } from 'rxjs';
import { takeUntil, take, map } from 'rxjs/operators';
import { Selectors, Actions as RootActions } from 'store/root-reducer';
import { Actions, ofType } from '@ngrx/effects';
import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';
import * as ScreeningActions from 'store/actions/search.actions';
var SearchesComponent = /** @class */ (function () {
    function SearchesComponent(cdf, store, actions$) {
        this.cdf = cdf;
        this.store = store;
        this.actions$ = actions$;
        this.unsubscribe$ = new Subject();
        this.engineType = SearchEngineTypeValue;
        this.screeningStatus = {};
        this.errors = [];
        this.invalidSearches = [];
        this.currentCRP$ = this.store.select(Selectors.customer.getCurrentCrp);
        this.refresh = new EventEmitter();
        this.refreshAll = new EventEmitter();
        this.getUpdatedScreeningResult = new EventEmitter();
    }
    Object.defineProperty(SearchesComponent.prototype, "searchEnginesList", {
        set: function (data) {
            if (!data) {
                return;
            }
            this.searchEngines = data;
            if (!this.selectedEngine) {
                this.selectedEngine = this.searchEngines[0];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchesComponent.prototype, "databaseSearch", {
        set: function (data) {
            var _this = this;
            if (data && (Object.entries(data).length !== 0)) {
                this.store.select(Selectors.billable.getSearchEngineTypes).pipe(take(1)).subscribe(function (engineTypes) {
                    _this.asyncSearchEngines = engineTypes;
                    _this.asyncSearchEngines.forEach(function (engine) {
                        _this.screeningStatus[engine] = false;
                    });
                    Object.keys(_this.screeningStatus).forEach(function (key) {
                        if (data[key] && data[key].results && data[key].results[0]) {
                            _this.screeningStatus[key] = data[key].results[0].isSearchFinished;
                        }
                        else {
                            _this.screeningStatus[key] = true;
                        }
                    });
                    if (_this.isScreening(data)) {
                        _this.quickScan = null;
                        _this.ongoingDueDiligence = null;
                        _this.screening = data;
                        _this.isOngoingDueDiligence = false;
                        _this.getInvalidSearches();
                        _this.setSelectedEngineData();
                    }
                    else if (_this.isQuickScan(data)) {
                        _this.screening = null;
                        _this.ongoingDueDiligence = null;
                        _this.quickScan = data;
                        _this.isOngoingDueDiligence = false;
                    }
                    else {
                        _this.screening = null;
                        _this.quickScan = null;
                        _this.ongoingDueDiligence = data;
                        if (_this.ongoingDueDiligence && Object.keys(_this.ongoingDueDiligence).length > 0) {
                            _this.isOngoingDueDiligence = true;
                        }
                        else {
                            _this.isOngoingDueDiligence = false;
                        }
                    }
                    _this.cdf.markForCheck();
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchesComponent.prototype, "recordName", {
        get: function () {
            return this._recordName;
        },
        set: function (value) {
            this._recordName = '';
            if (value) {
                this._recordName = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getLoadingStatus();
        combineLatest([
            merge(this.store.select(Selectors.record.getCorporateRecord), this.store.select(Selectors.record.getIndividualRecord)),
            this.store.select(Selectors.error.getScreeningErrors)
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (_a) {
            var res = _a[0], error = _a[1];
            if (res && error) {
                _this.record = res;
                _this.errors = error[res.id] ? error[res.id].data.failedSearches : [];
            }
            _this.cdf.detectChanges();
        });
        this.getScreeningResultWhenUpdated();
    };
    SearchesComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * Get loading status from store
     * @method getLoadingStatus
     */
    SearchesComponent.prototype.getLoadingStatus = function () {
        this.loadingAll$ = this.store.select(Selectors.search.getLoading)
            .pipe(takeUntil(this.unsubscribe$), map(function (screeningLoading) {
            return screeningLoading.includes(ScreeningActions.SearchActionTypes.POST_SCREENING) ||
                screeningLoading.includes(ScreeningActions.SearchActionTypes.GET_SCREENING);
        }));
    };
    /**
     * Emit the event to get screening result when comment or matched status is updated
     * @method getScreeningResultWhenUpdated
     */
    SearchesComponent.prototype.getScreeningResultWhenUpdated = function () {
        var _this = this;
        this.actions$.pipe(ofType(ScreeningActions.SearchActionTypes.PATCH_SEARCH_RESULT_SUCCESS), takeUntil(this.unsubscribe$))
            .subscribe(function () {
            _this.getUpdatedScreeningResult.emit(_this.selectedEngine.serviceType);
        });
    };
    SearchesComponent.prototype.isScreening = function (data) {
        return data.isScreening !== undefined;
    };
    SearchesComponent.prototype.isQuickScan = function (data) {
        return data.isQuickScan !== undefined;
    };
    SearchesComponent.prototype.setSelectedEngineData = function () {
        var currentDataSource = this.screening || this.quickScan || this.ongoingDueDiligence;
        this.selectedEngineData = currentDataSource[this.selectedEngine.serviceType];
    };
    SearchesComponent.prototype.onRefreshItemClicked = function () {
        this.refresh.emit(this.selectedEngine.serviceType);
    };
    SearchesComponent.prototype.onRefreshAllClicked = function () {
        this.refreshAll.emit();
    };
    SearchesComponent.prototype.onSelectSearchEngine = function (searchEngine) {
        this.selectedEngine = searchEngine;
        this.setSelectedEngineData();
    };
    SearchesComponent.prototype.usePreviousSearch = function (searchEngine) {
        this.store.dispatch(new RootActions.error.RemoveScreeningError({
            recordId: this.record.id,
            searchEngineType: (searchEngine || this.selectedEngine).serviceType
        }));
    };
    SearchesComponent.prototype.getInvalidSearches = function () {
        var _this = this;
        Object.keys(this.screening).forEach(function (key) {
            if (_this.screening[key] && _this.screening[key].results && _this.screening[key].results.length) {
                if (_this.screening[key].results[0].valid) {
                    _this.invalidSearches = _this.invalidSearches.filter(function (invalidSearch) { return invalidSearch !== _this.screening[key].engineType; });
                }
                else {
                    _this.invalidSearches.push(_this.screening[key].engineType);
                }
            }
        });
        this.cdf.detectChanges();
    };
    SearchesComponent.prototype.onScreeningCommentSubmitted = function (payload) {
        this.store.dispatch(new RootActions.search.PatchSearchResult(payload));
    };
    return SearchesComponent;
}());
export { SearchesComponent };
